import { useRouter } from 'next/router';
import { useQuery } from '@apollo/client';
import { GetAdDetailsResponse } from '@/api/types/ads.types';
import { GET_AD_DETAILS } from '@/api/queries/ads.queries';
import { usePlatformSource } from '@/hooks/usePlatformSource';
import { usePageType } from '@/hooks/usePageType/usePageType';
import { PageType } from '@/hooks/usePageType/usePageType.types';

export function useAdDetails({ skipQuery = false } = {}) {
  const {
    query: { slug },
  } = useRouter();
  const pageType = usePageType();
  const source = usePlatformSource();

  const legacyId = slug?.[2];

  const { data, loading, refetch, previousData } =
    useQuery<GetAdDetailsResponse>(GET_AD_DETAILS, {
      variables: {
        legacyId,
        source,
      },
      errorPolicy: 'all',
      skip:
        !legacyId ||
        pageType === PageType.NewAd ||
        pageType !== PageType.Ad ||
        skipQuery,
    });

  return { adDetails: data?.adDetails, loading, refetch, previousData };
}
